import { ORDER_API_PATHS } from '../constants/orders'
import type {
  ApiCheckout,
  ApiOrder,
  ListOrdersParams,
  PlaceOrderInput,
} from './types'
import { apiRequest } from './client'

export function fetchOrders(params: ListOrdersParams = {}): Promise<ApiOrder[]> {
  return apiRequest<ApiOrder[]>(ORDER_API_PATHS.root, {
    auth: true,
    query: {
      status: params.status,
      limit: params.limit,
    },
  })
}

export function fetchOrder(id: string): Promise<ApiOrder> {
  return apiRequest<ApiOrder>(ORDER_API_PATHS.item(id), { auth: true })
}

export function placeOrder(input: PlaceOrderInput): Promise<ApiCheckout> {
  return apiRequest<ApiCheckout>(ORDER_API_PATHS.root, {
    method: 'POST',
    auth: true,
    body: input,
  })
}

export function cancelOrder(id: string, reason?: string): Promise<ApiOrder> {
  return apiRequest<ApiOrder>(ORDER_API_PATHS.cancel(id), {
    method: 'POST',
    auth: true,
    body: reason?.trim() ? { reason: reason.trim() } : {},
  })
}
